import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { telemetryContextFor } from 'modules/Apollo/types';
import { TextCss } from 'styles';
import { DialogSettingsTable } from './DialogSettingsTable';
import { useDialogSettings } from './useDialogSettings';

export const DialogSettingsSection = (): React.ReactElement => {
  const { dialogVisibilityById, handleToggleDialogVisibility } = useDialogSettings({
    context: APOLLO_QUERY_CONTEXT,
  });

  return (
    <Stack vertical space="xsmall" data-testid="dialogs-confirmations-section">
      <Stack vertical>
        <Text variant="display1" display="block">
          {'Dialogs & Confirmations'}
        </Text>
        <Text css={TextCss.body2}>Manage dialog visibility in the table below.</Text>
      </Stack>

      <DialogSettingsTable
        dialogVisibilityById={dialogVisibilityById}
        onToggleDialogVisibility={handleToggleDialogVisibility}
      />
    </Stack>
  );
};

DialogSettingsSection.displayName = 'DialogSettingsSection';
const APOLLO_QUERY_CONTEXT = telemetryContextFor(DialogSettingsSection);
